module.exports = __webpack_public_path__ + "img/preview.a1aa738d.png";